import React from 'react';
import { Table } from 'react-bootstrap';

interface PaymentSummaryTableProps {
  paymentSummary: Array<{
    year: number;
    invoiceAmount: number;
    paidAmount: number;
  }>;
}

export const PaymentSummaryTable: React.FC<PaymentSummaryTableProps> = ({ paymentSummary }) => {
  return (
    <Table size="sm" bordered style={{ width: 'auto', margin: 0 }}>
      <thead>
        <tr>
          <th style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}>Year</th>
          <th style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}>Invoice Amount</th>
          <th style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}>Paid Amount</th>
        </tr>
      </thead>
      <tbody>
        {paymentSummary.map((summary) => (
          <tr key={summary.year}>
            <td style={{ fontSize: '0.9rem', padding: '0.5rem 0.75rem' }}>{summary.year}</td>
            <td
              style={{
                fontSize: '0.9rem',
                padding: '0.5rem 0.75rem',
                textAlign: 'right'
              }}>
              ${summary.invoiceAmount.toFixed(2)}
            </td>
            <td
              style={{
                fontSize: '0.9rem',
                padding: '0.5rem 0.75rem',
                textAlign: 'right',
                color: summary.paidAmount !== summary.invoiceAmount ? 'red' : undefined
              }}>
              ${summary.paidAmount.toFixed(2)}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};
